export default __webpack_public_path__ + "static/media/icon-info-red.8766c80a.svg";